<template>
  <div class="who_are_we">
    <div class="banner">
      <div class="banner_text">
        <h6>
          满分HR
        </h6>
        <p>可落地的人事一体化管理工具</p>
      </div>
      <!-- <img class="dingding_banner" src="../../assets/img/who_are_we/banner.png" alt=""> -->
    </div>
    <div class="content2">
      <ul>
        <li>
          <span class="left">
            <p style="font-size: 40px;font-weight: 500;">
              企业劳动力管理专家<br>
            <span style="font-size: 40px;font-weight: 500; background:linear-gradient(to right,#16A4FF,#004AFF);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;margin-top：10px !import;">让人力更简单</span>
        </p>
            <p  style="font-size: 25px;font-weight: 400;">上海效冠信息科技有限公司</p>
            <p>
              效冠科技创始团队深耕HR SAAS十余年，有丰富的客户服务经验与资源积累，同时与钉钉、企业微信、飞书有深入平台合作经验。效冠科技运用前沿科技为企业提供智能招聘、组织人事、考勤排班、薪酬绩效、人力发展等全链服务。基于企业人才战略与业务场景，提供符合业务需求的、全面的劳动力综合管理解决方案，致力于帮助企业实现精细化人效管理，提升组织运营效率，赋能中国企业实现“数字化人效”。
            </p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img class="content_img" src="../../assets/img/who_are_we/我们是谁-公司图.jpg">
          </span>
        </li>
      </ul>
    </div>
    <div class="index">
    <div class="index_item item2" id="item2">
      <div class="item_box" style="magin-top:-4%">
        <div class="flex justify-content-between">
          <div class="item">
            <img class="item_pic" src="../../assets/img/icon_yx.png" alt="" />
            <div class="itme_con">
              <div class="itme_con_til">优秀团队</div>
              <div class="itme_con_til_de">
                技术团队拥有多个大型计算机系统及人力资源类SAAS开发经验。
              </div>
            </div>
          </div>
          <div class="item">
            <img class="item_pic" src="../../assets/img/icon_ff.png" alt="" />
            <div class="itme_con">
              <div class="itme_con_til">经验丰富</div>
              <div class="itme_con_til_de">
                运营与市场团队经验丰富，从事人力资源、绩效管理、目标管理行业多年，为数千家企业客户提供从培训到落地服务。
              </div>
            </div>
          </div>
          <div class="item">
            <img class="item_pic" src="../../assets/img/icon_ys.png" alt="" />
            <div class="itme_con">
              <div class="itme_con_til">技术优势</div>
              <div class="itme_con_til_de">
                我们拥有成熟的系统应用与数据架构设计经验，丰富的行业知识图谱。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- <div class="certificates">
      <h6>
        正规安全
      </h6>
      <ul class="imgs_1">
        <li><img src="../../assets/img/who_are_we/certificate_1.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_2.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_3.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_4.png"></li>
      </ul>
      <ul class="imgs_2">
        <li><img src="../../assets/img/who_are_we/certificate_5.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_6.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_7.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_8.png"></li>
      </ul>
    </div> -->
  </div>
</template>
<script>
export default {
  data () {
    return {

    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {

  }
};
</script>
<style lang="scss">
.who_are_we {
  .banner {
    background: url('../../assets/img/who_are_we/我们是谁-顶.jpg') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner .banner_text {
    text-align: center;

    h6 {
      font-size: 40px;
      font-weight: 600;
      color: #ffffff;
    }

    p {
      font-size: 20px;
      color: #ffffff;
      font-weight: 400;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/whoAreWe.vue